<template>
  <b-row>
    <ServerError v-if="ServerError" />
    <vue-element-loading :active="appLoading" :is-full-screen="true">
      <img src="../../assets/loader.gif" />
    </vue-element-loading>
    <b-col cols="12" lg="12">
      <b-card no-header>
        <template slot="header">
          <b-row>
            <b-col cols="12" md="2" class="py-2">
              <span><b>Mammal Details</b></span>
            </b-col>
            
          </b-row>
        </template>
        <div v-if="report">
          
          
          <b-row v-if="report.photo" class="py-2 justify-content-md-center">
            <b-col cols="12" class="text-center">
              <img :src="baseURL+'/file/get/'+report.photo" width="auto" height="150px" />
            </b-col>
          </b-row>
          
         
          <b-row class="pt-3">

             <b-col cols="12" md="6">
              <b-form-group label="Common Name">
                <b-form-input
                  v-model="report.commonname"
                  type="text"
                  id="crimetype"
                  disabled
                  
                ></b-form-input>
              </b-form-group>
            </b-col> 
            <b-col cols="12" md="6">
              <b-form-group label="Local Name">
                <b-form-input
                  v-model="report.localname"
                  type="text"
                  id="lastname"
                  disabled
                  
                ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="6">
              <b-form-group label="Family">
                <b-form-input
                  v-model="report.family"
                  type="text"
                  id="middlename"
                  disabled
                 
                ></b-form-input>
              </b-form-group>
            </b-col> 
            <b-col cols="12" md="6">
              <b-form-group label="Latin Name">
                <b-form-input
                  v-model="report.latinname"
                  type="text"
                  id="firstname"
                  disabled
                  
                ></b-form-input>
              </b-form-group>
            </b-col>
            
            
            <b-col cols="12" md="12">
              <b-form-group label="Description">
                <b-form-textarea
                  id="lastknown"
                  v-model="report.description"
                  
                  rows="3"
                  disabled
                  max-rows="6"
                ></b-form-textarea>
              </b-form-group>
            </b-col>

           
            
            
           

            <b-col cols="12" md="6">
              <b-form-group label="Mammal Status ">
                <b-form-input disabled v-model="report.mammalstatus" id="mammalstatus" ></b-form-input>
              </b-form-group>
            </b-col>

             <b-col cols="12" md="6">
              <b-form-group label="Social Unit">
                <b-form-input disabled v-model="report.socialunit" id="socialunit" ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="6">
              <b-form-group label="Size">
                <b-form-input disabled v-model="report.size" id="size" ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="6">
              <b-form-group label="Behaviour">
                <b-form-input disabled v-model="report.behaviour" id="behaviour" ></b-form-input>
              </b-form-group>
            </b-col>

            <b-col cols="12" md="6">
              <b-form-group label="Distribution">
                <b-form-input disabled v-model="report.distribution" id="distribution" ></b-form-input>
              </b-form-group>
            </b-col>
           <b-col cols="12" md="6">
              <b-form-group label="Habitat">
                <b-form-input disabled v-model="report.habitat" id="habitat"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" md="6">
              <b-row>
                <b-col cols="12" md="5">
                  <span class="item_title">States of Distribution</span>
                </b-col>
                <b-col cols="12" md="7">
                  <span style="color:black" v-for="(item,i) in states" :key="i"  class="item_value">{{item.name}}</span>
                </b-col>
              </b-row>
              
              
            </b-col>
            <b-col cols="12" md="6"> </b-col>
          </b-row>
          <br/>
           
           <b-row>
            <b-col cols="12">
              <span class="item_title">Mammal Images</span>
            </b-col>

            <b-col cols="12" md="3" v-for="(item,i) in report.photos" :key="i" align="center" class="py-2">
              <img v-bind:src="baseURL+'/u/'+item.photo" width="100%" height="100%" />
            </b-col>
          </b-row>
        
         
          <b-row  class="justify-content-center">
            <div class="px-2">
              <b-button
                variant="outline-primary"
                size="sm"
                :to="'/editMammal/'+$route.params.id"
              >Edit Mammal</b-button>
            </div>
            <!-- <div class="px-2">
              <b-button
                variant="success"
                size="sm"
                v-if="report.isreviewed"
                @click.prevent="confirmVerifyReport('not verified.')"
              >Mark as Not Verified</b-button>
              <b-button
                variant="success"
                size="sm"
                v-else
                @click.prevent="confirmVerifyReport('verified.')"
              >Mark as Verified</b-button>
            </div>-->
            <div class="px-2">
              <b-button
                variant="danger"
                size="sm"
                @click.prevent="confirmRemoveReport"
              >Remove Mammal</b-button>
            </div> 
          </b-row>
        </div>
        <template slot="footer">
          <b-button @click="$router.go(-1)" size="sm">Back</b-button>
        </template>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
// import locationMap from "./map";
import axios from "axios";

export default {
  
  data() {
    return {
      report: null,
      appLoading: false,
      ServerError: false,
      rdate:null,
      expecteddeliverydate:null,
      // userRole: localStorage.getItem("role"),
      userRole:"admin",
      Attachments:null,
      userType: localStorage.getItem("usrType"),
      userRole: localStorage.getItem("role"),
      receiptfields: [
        // { key: "accountcreateat", label: "Created on", sortable: false },
        
        { key: "type", label: "Type ", sortable: false },
        { key: "files", label: "File", sortable: false },
      ],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      this.appLoading = true;
      axios({
        method: "GET",
        url: "/mammal/get",
        params: {
          id: this.$route.params.id
        },
        headers: {
         "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.report = response.data.data;
          if(this.report.states)
          this.states = this.report.states;
          this.Attachments = response.data.data.attachments;
          this.rdate = this.formatDate(this.report.added_date)
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    confirmRemoveReport() {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to Remove this Mammal.",
          {
            title: "Please Confirm",
            size: "md",
            buttonSize: "sm",
            okVariant: "danger",
            cancelVariant: "primary",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            this.removeReport();
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    confirmVerifyReport(item) {
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to mark this report as " + item,
          {
            title: "Please Confirm",
            size: "md",
            buttonSize: "sm",
            okVariant: "danger",
            cancelVariant: "primary",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          if (value) {
            this.verifyReport(item);
          }
        })
        .catch((err) => {
          // An error occurred
        });
    },
    removeReport() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/mammal/remove",
        data: {
          id: this.$route.params.id,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.$router.go(-1);
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    verifyReport(item) {
      this.appLoading = true;
      var status = false;
      if (item == "verified.") status = true;
      axios({
        method: "POST",
        url: "/report/reviewstatus",
        data: {
          status: status,
          id: this.$route.params.id,
        },
        headers: {
          "x-auth-token": localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.getData();
          // this.$router.go(-1);
        })
        .catch((e) => {
          this.ServerError = true;
        });
    },
    formatDate(item) {
      var dt = new Date(item);
      var day = dt.getDate();
      var year = dt.getFullYear();
      var hours = dt.getHours();
      var minutes = dt.getMinutes();
      dt = dt.toString();
      var ampm = hours >= 12 ? "pm" : "am";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime =
        day +
        " " +
        dt.slice(4, 7) +
        " " +
        year 
      return strTime;
    },
  },
};
</script>
<style scoped>
.form-control:disabled, 
.form-control[readonly] {
  background-color: #e4e7ea;
  opacity: 1;
  color: black;
}
</style>